// extracted by mini-css-extract-plugin
export default {"CreateProviderContent":"CreateProviderContent_CreateProviderContent__EhYGW"};